// import { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { Box, Grid, Paper, Typography, IconButton, Snackbar, Alert, Tooltip } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { VscNewFile } from 'react-icons/vsc';
// import { FaFileExcel } from 'react-icons/fa';
// import DeleteIcon from '@mui/icons-material/Delete';
// // src/hooks/useAuthData.js
// import { useAuth } from '../context/AuthContext';

// export default function CompanyDetail({ connectionString }) {
//     // const API = 'http://103.251.218.254:91/api/api/company';
//     const API = `${connectionString}/api/company`;
//     const { user } = useAuth();
//     const userId = user?.UserId;
//     const role = user?.UserCategory;

//     const [rows, setRows] = useState([]);
//     const [totalCount, setTotalCount] = useState(0);
//     const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
//     const [selectionModel, setSelectionModel] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//     useEffect(() => { fetchData(); }, [paginationModel]);

//     const fetchData = async () => {
//         setLoading(true);
//         try {
//             const { page, pageSize } = paginationModel;
//             const offset = page * pageSize;
//             const res = await axios.get(`${API}/search-by-user`, {
//                 params: {
//                     mode: 'search',
//                     offset,
//                     limit: pageSize,
//                     userId: userId,
//                 },
//                 headers: {
//                     'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
//                 }
//             });
//             console.log(res.data.data);
//             setRows(res.data.data || []);
//             setTotalCount(res.data.total || 0);
//             setSelectionModel([]);
//         } catch {
//             setSnackbar({ open: true, message: 'Failed to fetch data.', severity: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleDeleteMulti = async () => {
//         if (!selectionModel.length) return;
//         try {
//             const response = await axios.post(`${API}/delete`, { userId, objAryId: selectionModel });
//             setSnackbar({ open: true, message: response.data.message || 'Deleted successfully.', severity: 'success' });
//             fetchData();
//         } catch (error) {
//             const message = error.response?.status === 400 && error.response?.data?.error ? error.response.data.error : 'Delete failed due to an unexpected error.';
//             setSnackbar({ open: true, message, severity: 'error' });
//         }
//     };

//     const handleExport = () => {
//         axios({ url: `${API}/search?mode=export`, method: 'GET', responseType: 'blob', })
//             .then((resp) => {
//                 const url = window.URL.createObjectURL(new Blob([resp.data]));
//                 const link = document.createElement('a');
//                 link.href = url;
//                 link.setAttribute('download', 'companies.xlsx');
//                 document.body.appendChild(link);
//                 link.click();
//                 link.remove();
//             })
//             .catch(() => { setSnackbar({ open: true, message: 'Export failed.', severity: 'error' }); });
//     };

//     const columns = [
//         {
//             field: 'CompanyName', headerName: 'Company', flex: 1.5, minWidth: 150,
//             renderCell: (params) => {
//                 const companyId = params.row.CompId;
//                 const companyName = params.value;

//                 const handleClick = (e) => {
//                     // Check if the user is a 'User' and show 403 Forbidden error message
//                     if (role === 'User') {
//                         e.preventDefault(); // Prevent the navigation
//                         setSnackbar({ open: true, message: '403 Forbidden: Access Denied', severity: 'warning' });
//                     }
//                 };

//                 return (
//                     <Link
//                         to={`/main/editCompany/${companyId}`}
//                         style={{ color: '#1976d2', textDecoration: 'underline', fontWeight: 500, fontSize: '0.875rem' }}
//                         onClick={handleClick}
//                     >
//                         {companyName || '—'}
//                     </Link>
//                 );
//             }
//         },
//         { field: 'GSTNo', headerName: 'GST No.', flex: 1, minWidth: 120 },
//         { field: 'ContactPerson', headerName: 'Contact', flex: 1, minWidth: 120 },
//         { field: 'MobileNo', headerName: 'Mobile', flex: 0.7, minWidth: 120, align: 'right', headerAlign: 'right' },
//         {
//             field: 'location', headerName: 'Location', flex: 0.45, minWidth: 120,
//             renderCell: (params) => {
//                 const { City, State, Country } = params.row;
//                 return (
//                     <Box sx={{ py: 1, display: 'flex', flexDirection: 'column' }}>
//                         <Typography sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}> {City || '—'} </Typography>
//                         <Typography sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}> {State || '—'} </Typography>
//                         <Typography sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}> {Country || '—'} </Typography>
//                     </Box>
//                 );
//             }
//         },
//     ];

//     if (role !== "User") {
//         columns.push({
//             width: 40,
//             sortable: false,
//             filterable: false,
//             align: "center",
//             headerAlign: "center",
//             renderCell: ({ row }) => {
//                 const isSelected = selectionModel.includes(row.CompId);
//                 return (
//                     <Tooltip title="Delete Selected">
//                         <span>
//                             <IconButton
//                                 onClick={handleDeleteMulti}
//                                 color="error"
//                                 disabled={!isSelected}
//                                 size="small"
//                             >
//                                 <DeleteIcon />
//                             </IconButton>
//                         </span>
//                     </Tooltip>
//                 );
//             },
//         });
//     }

//     return (
//         <Box sx={{ pt: 1 }}>
//             {/* Toolbar */}
//             <Grid container alignItems="center">
//                 <Grid item xs={2}>
//                     <Tooltip title="Add New Company">
//                         <IconButton component={Link} to="/main/newCompany" sx={{ color: 'orange' }}>
//                             <VscNewFile size={20} />
//                         </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Export to Excel">
//                         <IconButton onClick={handleExport} color="success">
//                             <FaFileExcel />
//                         </IconButton>
//                     </Tooltip>
//                 </Grid>
//                 <Grid item xs={8} sx={{ textAlign: 'center' }}>
//                     <Typography variant="h5">Company Details</Typography>
//                 </Grid>
//                 <Grid item xs={2} sx={{ textAlign: 'right' }}></Grid>
//             </Grid>

//             {/* DataGrid */}
//             <Paper sx={{ mt: 1, borderRadius: 2, marginX: 1 }}>
//                 <Box sx={{ overflow: 'auto', maxHeight: '80vh' }}>
//                     <DataGrid
//                         autoHeight
//                         rows={rows}
//                         columns={columns}
//                         getRowId={r => r.CompId}
//                         getRowHeight={() => 'auto'}
//                         checkboxSelection={role !== "User"}
//                         selectionModel={selectionModel}
//                         onSelectionModelChange={newSel => setSelectionModel(newSel)}
//                         disableSelectionOnClick
//                         loading={loading}
//                         pagination
//                         pageSize={paginationModel.pageSize}
//                         page={paginationModel.page}
//                         rowCount={totalCount}
//                         paginationMode="server"
//                         onPageChange={p => setPaginationModel(m => ({ ...m, page: p }))}
//                         onPageSizeChange={ps => setPaginationModel(m => ({ ...m, pageSize: ps }))}
//                         rowsPerPageOptions={[50, 100, 150]}
//                         sx={{
//                             '& .MuiDataGrid-columnHeaders': { backgroundColor: '#165bb5', color: '#FFFFFF', fontWeight: 'bold' },
//                             '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
//                             '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#ecf4fc' },
//                             '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-columnHeaderTitleContainer': { color: '#ffffff' },
//                             '& .MuiDataGrid-columnHeader .MuiSvgIcon-root': { color: '#ffffff' },
//                             '& .MuiDataGrid-columnHeader .MuiIconButton-root': { color: '#ffffff' },
//                             '& .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-filterIcon': { color: '#ffffff' },
//                             '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': { outline: 'none' }
//                         }}
//                     />
//                 </Box>
//             </Paper>

//             {/* Snackbar */}
//             <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//                 <Alert severity={snackbar.severity} variant="filled">
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// }









// import { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { Box, Grid, Paper, Typography, IconButton, Snackbar, Alert, Tooltip, Card, CardContent, Avatar, Checkbox, useMediaQuery, useTheme } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { VscNewFile } from 'react-icons/vsc';
// import { FaFileExcel } from 'react-icons/fa';
// import DeleteIcon from '@mui/icons-material/Delete';
// import PhoneIcon from '@mui/icons-material/Phone';
// import PersonIcon from '@mui/icons-material/Person';
// import ReceiptIcon from '@mui/icons-material/Receipt';
// import { useAuth } from '../context/AuthContext';
// import TextField from '@mui/material/TextField';
// import InputAdornment from '@mui/material/InputAdornment';
// import SearchIcon from '@mui/icons-material/Search';
// import dataGridSx from '../components/datagridComponent';

// function stringToColor(string) {
//     let hash = 0;
//     for (let i = 0; i < string.length; i++) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
//     return colors[Math.abs(hash) % colors.length];
// }

// function getInitials(name) {
//     if (!name) return 'C';
//     return name.trim().charAt(0).toUpperCase();
// }

// export default function CompanyDetail({ connectionString }) {
//     const API = `${connectionString}/api/company`;
//     const { user } = useAuth();
//     const userId = user?.UserId;
//     const role = user?.UserCategory;

//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md')); // Cards on < md

//     const [rows, setRows] = useState([]);
//     const [totalCount, setTotalCount] = useState(0);
//     const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
//     const [selectionModel, setSelectionModel] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
//     const [searchQuery, setSearchQuery] = useState('');
//     const [selectAll, setSelectAll] = useState(false); // For bulk Select All
//     const [debouncedSearch, setDebouncedSearch] = useState('');
//     const [filterModel, setFilterModel] = useState({ items: [] });
//     const [sortModel, setSortModel] = useState([]);

//     useEffect(() => {
//         fetchData();
//     }, [paginationModel.page, paginationModel.pageSize]);

//     useEffect(() => {
//         const t = setTimeout(() => {
//             setDebouncedSearch(searchQuery);

//             // ALWAYS reset page to 0 on search
//             setPaginationModel(prev => ({ ...prev, page: 0 }));
//         }, 400);

//         return () => clearTimeout(t);
//     }, [searchQuery]);

//     const fetchData = async () => {
//         setLoading(true);
//         try {
//             const { page, pageSize } = paginationModel;
//             const offset = page * pageSize;
//             const res = await axios.get(`${API}/search-by-user`, {
//                 params: {
//                     mode: 'search',
//                     offset,
//                     limit: pageSize,
//                     userId: userId,
//                 },
//                 headers: {
//                     'Cache-Control': 'no-store'
//                 }
//             });
//             setRows(res.data.data || []);
//             setTotalCount(res.data.total || 0);
//             setSelectionModel([]);
//             setSelectAll(false);
//         } catch {
//             setSnackbar({ open: true, message: 'Failed to fetch data.', severity: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleDeleteMulti = async () => {
//         if (!selectionModel.length) return;
//         try {
//             const response = await axios.post(`${API}/delete`, { userId, objAryId: selectionModel });
//             setSnackbar({ open: true, message: response.data.message || 'Deleted successfully.', severity: 'success' });
//             fetchData();
//         } catch (error) {
//             const message = error.response?.status === 400 && error.response?.data?.error
//                 ? error.response.data.error
//                 : 'Delete failed due to an unexpected error.';
//             setSnackbar({ open: true, message, severity: 'error' });
//         }
//     };

//     const handleExport = () => {
//         axios({
//             url: `${API}/search?mode=export`,
//             method: 'GET',
//             responseType: 'blob',
//         })
//             .then((resp) => {
//                 const url = window.URL.createObjectURL(new Blob([resp.data]));
//                 const link = document.createElement('a');
//                 link.href = url;
//                 link.setAttribute('download', 'companies.xlsx');
//                 document.body.appendChild(link);
//                 link.click();
//                 link.remove();
//             })
//             .catch(() => {
//                 setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
//             });
//     };

//     const toggleSelectAll = () => {
//         if (selectAll) {
//             setSelectionModel([]);
//             setSelectAll(false);
//         } else {
//             const allIds = rows.map(row => row.CompId);
//             setSelectionModel(allIds);
//             setSelectAll(true);
//         }
//     };

//     const columns = [
//         {
//             field: 'CompanyName', headerName: 'Company', flex: 1.5, minWidth: 150,
//             renderCell: (params) => {
//                 const companyId = params.row.CompId;
//                 const companyName = params.value;

//                 const handleClick = (e) => {
//                     if (role === 'User') {
//                         e.preventDefault();
//                         setSnackbar({ open: true, message: '403 Forbidden: Access Denied', severity: 'warning' });
//                     }
//                 };

//                 return (
//                     <Link to={`/main/editCompany/${companyId}`} style={{ color: '#1976d2', textDecoration: 'underline', fontWeight: 500, fontSize: '0.875rem' }} onClick={handleClick} > {companyName || '—'} </Link>
//                 );
//             }
//         },
//         { field: 'GSTNo', headerName: 'GST No.', flex: 1, minWidth: 120 },
//         { field: 'ContactPerson', headerName: 'Contact', flex: 1, minWidth: 120 },
//         { field: 'MobileNo', headerName: 'Mobile', flex: 0.7, minWidth: 120, align: 'right', headerAlign: 'right' },
//         {
//             field: 'location', headerName: 'Location', flex: 0.45, minWidth: 120,
//             renderCell: (params) => {
//                 const { City, State, Country } = params.row;
//                 return (
//                     <Box sx={{ py: 1, display: 'flex', flexDirection: 'column' }}>
//                         <Typography sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}>{City || '—'}</Typography>
//                         <Typography sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}>{State || '—'}</Typography>
//                         <Typography sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}>{Country || '—'}</Typography>
//                     </Box>
//                 );
//             }
//         },
//     ];

//     if (role !== "User") {
//         columns.push({
//             width: 40,
//             sortable: false,
//             filterable: false,
//             align: "center",
//             headerAlign: "center",
//             renderCell: ({ row }) => {
//                 const isSelected = selectionModel.includes(row.CompId);
//                 return (
//                     <Tooltip title="Delete Selected">
//                         <span>
//                             <IconButton onClick={handleDeleteMulti} color="error" disabled={!isSelected} size="small" >
//                                 <DeleteIcon />
//                             </IconButton>
//                         </span>
//                     </Tooltip>
//                 );
//             },
//         });
//     }

//     // Enhanced Card View with Checkbox Selection
//     const renderCards = () => {
//         if (loading) return <Typography sx={{ p: 4, textAlign: 'center' }}>Loading...</Typography>;
//         if (rows.length === 0) return <Typography sx={{ p: 4, textAlign: 'center' }}>No companies found.</Typography>;

//         const filteredRows = rows.filter((row) =>
//             (row.CompanyName || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
//             (row.ContactPerson || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
//             (row.GSTNo || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
//             (row.MobileNo || '').toString().includes(searchQuery)
//         );

//         if (filteredRows.length === 0) {
//             return <Typography sx={{ p: 4, textAlign: 'center' }}>No companies found matching your search.</Typography>;
//         }

//         return filteredRows.map((row) => {
//             const isSelected = selectionModel.includes(row.CompId);
//             const avatarColor = stringToColor(row.CompanyName || 'Company');
//             const initials = getInitials(row.CompanyName);

//             const locationText = [row.City, row.State, row.Country].filter(Boolean).join(', ') || '—';

//             const toggleSelection = (e) => {
//                 e.stopPropagation();
//                 setSelectionModel(prev => prev.includes(row.CompId) ? prev.filter(id => id !== row.CompId) : [...prev, row.CompId]);
//                 // Update selectAll state
//                 if (selectionModel.length + 1 === filteredRows.length) {
//                     setSelectAll(true);
//                 } else if (selectionModel.length === filteredRows.length) {
//                     setSelectAll(false);
//                 }
//             };

//             return (
//                 <Card key={row.CompId} sx={{ mb: 1.5, boxShadow: 3, borderRadius: 2, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 5 } }}
//                     onClick={() => {
//                         if (role === 'User') {
//                             setSnackbar({ open: true, message: '403 Forbidden: Access Denied', severity: 'warning' });
//                             return;
//                         }
//                         window.location.href = `/main/editCompany/${row.CompId}`;
//                     }}
//                 >
//                     <CardContent sx={{ py: 1.8, px: 1.5, pb: '12px !important' }}>
//                         <Grid container alignItems="flex-start" spacing={1.5}>
//                             {/* Checkbox */}
//                             {role !== 'User' && (
//                                 <Grid item>
//                                     <Checkbox checked={isSelected} onChange={toggleSelection} onClick={(e) => e.stopPropagation()} size="small" sx={{ p: 0.2, pt: 2, mr: 0 }} />
//                                 </Grid>
//                             )}

//                             {/* Main Content */}
//                             <Grid item xs zeroMinWidth>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                     <Avatar sx={{ bgcolor: avatarColor, width: 36, height: 36, fontWeight: 'bold', mr: 1.5, flexShrink: 0 }} > {initials} </Avatar>
//                                     <Box sx={{ minWidth: 0, flexGrow: 1 }}>
//                                         <Typography variant="h6" sx={{ color: '#1976d2', textDecoration: 'none', fontWeight: 600, fontSize: { xs: '1rem', sm: '1.1rem' }, }} > {row.CompanyName || '—'} </Typography>
//                                         <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.3 }}> {locationText} </Typography>
//                                     </Box>
//                                 </Box>

//                                 <Box sx={{ mt: 1.5 }}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                         <PersonIcon fontSize="small" sx={{ color: 'text.secondary', mr: 1, flexShrink: 0 }} />
//                                         <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}> {row.ContactPerson || 'N/A'} </Typography>
//                                     </Box>

//                                     <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                         <ReceiptIcon fontSize="small" sx={{ color: 'text.secondary', mr: 1, flexShrink: 0 }} />
//                                         <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}> {row.GSTNo || 'N/A'} </Typography>
//                                     </Box>

//                                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                         <PhoneIcon fontSize="small" sx={{ color: 'primary.main', mr: 1, flexShrink: 0 }} />
//                                         <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 500 }}> {row.MobileNo || '—'} </Typography>
//                                     </Box>
//                                 </Box>
//                             </Grid>
//                         </Grid>
//                     </CardContent>
//                 </Card>
//             );
//         });
//     };

//     return (
//         <Box sx={{ pt: 1, px: { xs: 2, sm: 3, md: 4 }, ml: 2 }}>
//             {/* Toolbar - Fully Responsive */}
//             <Grid container spacing={2} alignItems="center" sx={{ mb: 0 }}>
//                 <Grid item>
//                     <Box sx={{ display: 'flex', gap: 1 }}>
//                         <Tooltip title="Add New Company">
//                             <IconButton component={Link} to="/main/newCompany" sx={{ color: "orange" }} >
//                                 <VscNewFile size={22} />
//                             </IconButton>
//                         </Tooltip>
//                         <Tooltip title="Export to Excel">
//                             <IconButton onClick={handleExport} color="success">
//                                 <FaFileExcel size={20} />
//                             </IconButton>
//                         </Tooltip>
//                     </Box>
//                 </Grid>

//                 <Grid item xs zeroMinWidth>
//                     <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600 }} > Company Details </Typography>
//                 </Grid>

//                 <Grid item>
//                     <Box sx={{ width: { xs: 48, sm: 96 } }} />
//                 </Grid>
//             </Grid>

//             {/* Content */}
//             <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
//                 <Box sx={{ p: { xs: 1, md: 2 } }}>

//                     {isSmallScreen && (
//                         <Box sx={{ mb: 2, px: 1 }}>
//                             <TextField fullWidth size="small" placeholder="Search companies..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
//                                 InputProps={{
//                                     startAdornment: (
//                                         <InputAdornment position="start">
//                                             <SearchIcon />
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Box>
//                     )}

//                     {/* Bulk Action Bar - Only on small screens when items selected */}
//                     {isSmallScreen && role !== 'User' && selectionModel.length > 0 && (
//                         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }} >
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" />
//                                 <Typography variant="body2" sx={{ ml: 1 }}> {selectionModel.length} selected </Typography>
//                             </Box>
//                             <Tooltip title="Delete selected">
//                                 <IconButton onClick={handleDeleteMulti} color="error">
//                                     <DeleteIcon />
//                                 </IconButton>
//                             </Tooltip>
//                         </Box>
//                     )}

//                     {isSmallScreen ? (
//                         <Box sx={{ width: '100%', overflowX: 'hidden', px: 1 }}>
//                             {renderCards()}
//                         </Box>
//                     ) : (
//                         <Box sx={{ height: '80vh', width: '100%' }}>
//                             {/* <DataGrid autoHeight={false} rows={rows} columns={columns} getRowId={(r) => r.CompId} getRowHeight={() => 'auto'} checkboxSelection={role !== "User"} selectionModel={selectionModel} onSelectionModelChange={(newSel) => setSelectionModel(newSel)} disableSelectionOnClick loading={loading} pagination pageSize={paginationModel.pageSize} page={paginationModel.page} rowCount={totalCount} paginationMode="server" onPageChange={(p) => setPaginationModel((m) => ({ ...m, page: p }))} onPageSizeChange={(ps) => setPaginationModel((m) => ({ ...m, pageSize: ps }))} rowsPerPageOptions={[50, 100, 150]}
//                                 sx={dataGridSx}
//                             /> */}

//                             <DataGrid
//                                 autoHeight={false}
//                                 rows={rows}
//                                 columns={columns}
//                                 getRowId={(r) => r.CompId}
//                                 getRowHeight={() => 'auto'}
//                                 checkboxSelection={role !== "User"}
//                                 rowSelectionModel={selectionModel}
//                                 onRowSelectionModelChange={(newSel) => setSelectionModel(newSel)}
//                                 loading={loading}
//                                 rowCount={totalCount}
//                                 paginationMode="server"
//                                 paginationModel={paginationModel}
//                                 onPaginationModelChange={(model) => { setPaginationModel(model); }}
//                                 pageSizeOptions={[3, 25, 50, 100]}
//                                 sx={dataGridSx}
//                             />
//                         </Box>
//                     )}
//                 </Box>
//             </Paper>

//             {/* Snackbar */}
//             <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//                 <Alert severity={snackbar.severity} variant="filled">
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// }












// import { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { Box, Grid, Paper, Typography, IconButton, Snackbar, Alert, Tooltip, Card, CardContent, Avatar, Checkbox, useMediaQuery, useTheme } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { VscNewFile } from 'react-icons/vsc';
// import { FaFileExcel } from 'react-icons/fa';
// import DeleteIcon from '@mui/icons-material/Delete';
// import PhoneIcon from '@mui/icons-material/Phone';
// import PersonIcon from '@mui/icons-material/Person';
// import ReceiptIcon from '@mui/icons-material/Receipt';
// import { useAuth } from '../context/AuthContext';
// import TextField from '@mui/material/TextField';
// import InputAdornment from '@mui/material/InputAdornment';
// import SearchIcon from '@mui/icons-material/Search';
// import CommonServerDataGrid from '../components/datagridComponent';

// function stringToColor(string) {
//     let hash = 0;
//     for (let i = 0; i < string.length; i++) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
//     return colors[Math.abs(hash) % colors.length];
// }

// function getInitials(name) {
//     if (!name) return 'C';
//     return name.trim().charAt(0).toUpperCase();
// }

// export default function CompanyDetail({ connectionString }) {
//     const API = `${connectionString}/api/company`;
//     const { user } = useAuth();
//     const userId = user?.UserId;
//     const role = user?.UserCategory;

//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md')); // Cards on < md

//     const [rows, setRows] = useState([]);
//     const [totalCount, setTotalCount] = useState(0);
//     const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
//     const [selectionModel, setSelectionModel] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
//     const [searchQuery, setSearchQuery] = useState('');
//     const [selectAll, setSelectAll] = useState(false); // For bulk Select All
//     const [debouncedSearch, setDebouncedSearch] = useState('');
//     const [filterModel, setFilterModel] = useState({ items: [] });
//     const [sortModel, setSortModel] = useState([]);

//     const mapCompanyFilters = (filterModel, params) => {
//         filterModel.items.forEach(item => {
//             if (!item.value) return;

//             switch (item.field) {
//                 case 'CompanyName':
//                     params.companyName = item.value;
//                     break;
//                 case 'GSTNo':
//                     params.gstNo = item.value;
//                     break;
//                 case 'ContactPerson':
//                     params.contactPerson = item.value;
//                     break;
//                 case 'MobileNo':
//                     params.mobileNo = item.value;
//                     break;
//                 default:
//                     break;
//             }
//         });
//     };

//     const mapCompanySort = (sortModel, params) => {
//         if (!sortModel.length) return;

//         const { field, sort } = sortModel[0];
//         params.orderBy = `${field} ${sort.toUpperCase()}`;
//     };


//     // useEffect(() => {
//     //     fetchData();
//     // }, [paginationModel.page, paginationModel.pageSize]);

//     // useEffect(() => {
//     //     const t = setTimeout(() => {
//     //         setDebouncedSearch(searchQuery);

//     //         // ALWAYS reset page to 0 on search
//     //         setPaginationModel(prev => ({ ...prev, page: 0 }));
//     //     }, 400);

//     //     return () => clearTimeout(t);
//     // }, [searchQuery]);

//     // const fetchData = async () => {
//     //     setLoading(true);
//     //     try {
//     //         const { page, pageSize } = paginationModel;
//     //         const offset = page * pageSize;
//     //         const res = await axios.get(`${API}/search-by-user`, {
//     //             params: {
//     //                 mode: 'search',
//     //                 offset,
//     //                 limit: pageSize,
//     //                 userId: userId,
//     //             },
//     //             headers: {
//     //                 'Cache-Control': 'no-store'
//     //             }
//     //         });
//     //         setRows(res.data.data || []);
//     //         setTotalCount(res.data.total || 0);
//     //         setSelectionModel([]);
//     //         setSelectAll(false);
//     //     } catch {
//     //         setSnackbar({ open: true, message: 'Failed to fetch data.', severity: 'error' });
//     //     } finally {
//     //         setLoading(false);
//     //     }
//     // };

//     const handleDeleteMulti = async () => {
//         if (!selectionModel.length) return;
//         try {
//             const response = await axios.post(`${API}/delete`, { userId, objAryId: selectionModel });
//             setSnackbar({ open: true, message: response.data.message || 'Deleted successfully.', severity: 'success' });
//             setPaginationModel(p => ({ ...p }));
//         } catch (error) {
//             const message = error.response?.status === 400 && error.response?.data?.error ? error.response.data.error : 'Delete failed due to an unexpected error.';
//             setSnackbar({ open: true, message, severity: 'error' });
//         }
//     };

//     const handleExport = () => {
//         axios({
//             url: `${API}/search?mode=export`,
//             method: 'GET',
//             responseType: 'blob',
//         })
//             .then((resp) => {
//                 const url = window.URL.createObjectURL(new Blob([resp.data]));
//                 const link = document.createElement('a');
//                 link.href = url;
//                 link.setAttribute('download', 'companies.xlsx');
//                 document.body.appendChild(link);
//                 link.click();
//                 link.remove();
//             })
//             .catch(() => {
//                 setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
//             });
//     };

//     const toggleSelectAll = () => {
//         if (selectAll) {
//             setSelectionModel([]);
//             setSelectAll(false);
//         } else {
//             const allIds = rows.map(row => row.CompId);
//             setSelectionModel(allIds);
//             setSelectAll(true);
//         }
//     };

//     const columns = [
//         {
//             field: 'CompanyName', headerName: 'Company', flex: 1.5, minWidth: 150,
//             renderCell: (params) => {
//                 const companyId = params.row.CompId;
//                 const companyName = params.value;

//                 const handleClick = (e) => {
//                     if (role === 'User') {
//                         e.preventDefault();
//                         setSnackbar({ open: true, message: '403 Forbidden: Access Denied', severity: 'warning' });
//                     }
//                 };

//                 return (
//                     <Link to={`/main/editCompany/${companyId}`} style={{ color: '#1976d2', textDecoration: 'underline', fontWeight: 500, fontSize: '0.875rem' }} onClick={handleClick} > {companyName || '—'} </Link>
//                 );
//             }
//         },
//         { field: 'GSTNo', headerName: 'GST No.', flex: 1, minWidth: 120 },
//         { field: 'ContactPerson', headerName: 'Contact', flex: 1, minWidth: 120 },
//         { field: 'MobileNo', headerName: 'Mobile', flex: 0.7, minWidth: 120, align: 'right', headerAlign: 'right' },
//         {
//             field: 'location', headerName: 'Location', flex: 0.45, minWidth: 120,
//             renderCell: (params) => {
//                 const { City, State, Country } = params.row;
//                 return (
//                     <Box sx={{ py: 1, display: 'flex', flexDirection: 'column' }}>
//                         <Typography sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}>{City || '—'}</Typography>
//                         <Typography sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}>{State || '—'}</Typography>
//                         <Typography sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}>{Country || '—'}</Typography>
//                     </Box>
//                 );
//             }
//         },
//     ];

//     if (role !== "User") {
//         columns.push({
//             width: 40, sortable: false, filterable: false, align: "center", headerAlign: "center",
//             renderCell: ({ row }) => {
//                 const isSelected = selectionModel.includes(row.CompId);
//                 return (
//                     <Tooltip title="Delete Selected">
//                         <span>
//                             <IconButton onClick={handleDeleteMulti} color="error" disabled={!isSelected} size="small" >
//                                 <DeleteIcon />
//                             </IconButton>
//                         </span>
//                     </Tooltip>
//                 );
//             },
//         });
//     }

//     // Enhanced Card View with Checkbox Selection
//     const renderCards = () => {
//         if (loading) return <Typography sx={{ p: 4, textAlign: 'center' }}>Loading...</Typography>;
//         if (rows.length === 0) return <Typography sx={{ p: 4, textAlign: 'center' }}>No companies found.</Typography>;

//         const filteredRows = rows.filter((row) =>
//             (row.CompanyName || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
//             (row.ContactPerson || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
//             (row.GSTNo || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
//             (row.MobileNo || '').toString().includes(searchQuery)
//         );

//         if (filteredRows.length === 0) {
//             return <Typography sx={{ p: 4, textAlign: 'center' }}>No companies found matching your search.</Typography>;
//         }

//         return filteredRows.map((row) => {
//             const isSelected = selectionModel.includes(row.CompId);
//             const avatarColor = stringToColor(row.CompanyName || 'Company');
//             const initials = getInitials(row.CompanyName);

//             const locationText = [row.City, row.State, row.Country].filter(Boolean).join(', ') || '—';

//             const toggleSelection = (e) => {
//                 e.stopPropagation();
//                 setSelectionModel(prev => prev.includes(row.CompId) ? prev.filter(id => id !== row.CompId) : [...prev, row.CompId]);
//                 // Update selectAll state
//                 if (selectionModel.length + 1 === filteredRows.length) {
//                     setSelectAll(true);
//                 } else if (selectionModel.length === filteredRows.length) {
//                     setSelectAll(false);
//                 }
//             };

//             return (
//                 <Card key={row.CompId} sx={{ mb: 1.5, boxShadow: 3, borderRadius: 2, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 5 } }}
//                     onClick={() => {
//                         if (role === 'User') {
//                             setSnackbar({ open: true, message: '403 Forbidden: Access Denied', severity: 'warning' });
//                             return;
//                         }
//                         window.location.href = `/main/editCompany/${row.CompId}`;
//                     }}
//                 >
//                     <CardContent sx={{ py: 1.8, px: 1.5, pb: '12px !important' }}>
//                         <Grid container alignItems="flex-start" spacing={1.5}>
//                             {/* Checkbox */}
//                             {role !== 'User' && (
//                                 <Grid item>
//                                     <Checkbox checked={isSelected} onChange={toggleSelection} onClick={(e) => e.stopPropagation()} size="small" sx={{ p: 0.2, pt: 2, mr: 0 }} />
//                                 </Grid>
//                             )}

//                             {/* Main Content */}
//                             <Grid item xs zeroMinWidth>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                     <Avatar sx={{ bgcolor: avatarColor, width: 36, height: 36, fontWeight: 'bold', mr: 1.5, flexShrink: 0 }} > {initials} </Avatar>
//                                     <Box sx={{ minWidth: 0, flexGrow: 1 }}>
//                                         <Typography variant="h6" sx={{ color: '#1976d2', textDecoration: 'none', fontWeight: 600, fontSize: { xs: '1rem', sm: '1.1rem' }, }} > {row.CompanyName || '—'} </Typography>
//                                         <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.3 }}> {locationText} </Typography>
//                                     </Box>
//                                 </Box>

//                                 <Box sx={{ mt: 1.5 }}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                         <PersonIcon fontSize="small" sx={{ color: 'text.secondary', mr: 1, flexShrink: 0 }} />
//                                         <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}> {row.ContactPerson || 'N/A'} </Typography>
//                                     </Box>

//                                     <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                         <ReceiptIcon fontSize="small" sx={{ color: 'text.secondary', mr: 1, flexShrink: 0 }} />
//                                         <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}> {row.GSTNo || 'N/A'} </Typography>
//                                     </Box>

//                                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                         <PhoneIcon fontSize="small" sx={{ color: 'primary.main', mr: 1, flexShrink: 0 }} />
//                                         <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 500 }}> {row.MobileNo || '—'} </Typography>
//                                     </Box>
//                                 </Box>
//                             </Grid>
//                         </Grid>
//                     </CardContent>
//                 </Card>
//             );
//         });
//     };

//     return (
//         <Box sx={{ pt: 1, px: { xs: 2, sm: 3, md: 4 }, ml: 2 }}>
//             {/* Toolbar - Fully Responsive */}
//             <Grid container spacing={2} alignItems="center" sx={{ mb: 0 }}>
//                 <Grid item>
//                     <Box sx={{ display: 'flex', gap: 1 }}>
//                         <Tooltip title="Add New Company">
//                             <IconButton component={Link} to="/main/newCompany" sx={{ color: "orange" }} >
//                                 <VscNewFile size={22} />
//                             </IconButton>
//                         </Tooltip>
//                         <Tooltip title="Export to Excel">
//                             <IconButton onClick={handleExport} color="success">
//                                 <FaFileExcel size={20} />
//                             </IconButton>
//                         </Tooltip>
//                     </Box>
//                 </Grid>

//                 <Grid item xs zeroMinWidth>
//                     <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600 }} > Company Details </Typography>
//                 </Grid>

//                 <Grid item>
//                     <Box sx={{ width: { xs: 48, sm: 96 } }} />
//                 </Grid>
//             </Grid>

//             {/* Content */}
//             <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
//                 <Box sx={{ p: { xs: 1, md: 2 } }}>

//                     {isSmallScreen && (
//                         <Box sx={{ mb: 2, px: 1 }}>
//                             <TextField fullWidth size="small" placeholder="Search companies..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
//                                 InputProps={{
//                                     startAdornment: (
//                                         <InputAdornment position="start">
//                                             <SearchIcon />
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Box>
//                     )}

//                     {/* Bulk Action Bar - Only on small screens when items selected */}
//                     {isSmallScreen && role !== 'User' && selectionModel.length > 0 && (
//                         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }} >
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" />
//                                 <Typography variant="body2" sx={{ ml: 1 }}> {selectionModel.length} selected </Typography>
//                             </Box>
//                             <Tooltip title="Delete selected">
//                                 <IconButton onClick={handleDeleteMulti} color="error">
//                                     <DeleteIcon />
//                                 </IconButton>
//                             </Tooltip>
//                         </Box>
//                     )}

//                     {isSmallScreen ? (
//                         <Box sx={{ width: '100%', overflowX: 'hidden', px: 1 }}>
//                             {renderCards()}
//                         </Box>
//                     ) : (
//                         <Box sx={{ height: '80vh', width: '100%' }}>
//                             <CommonServerDataGrid
//                                 columns={columns}
//                                 api={{
//                                     fetchUrl: `${API}/search-by-user`,
//                                 }}
//                                 getRowId={(row) => row.CompId}
//                                 role={role}
//                                 userId={userId}
//                                 companyId={null}          // not used here
//                                 pageSizeOptions={[3, 25, 50, 100]}
//                                 mapFiltersToParams={mapCompanyFilters}
//                                 mapSortToParams={mapCompanySort}
//                                 selectionModel={selectionModel}
//                                 onSelectionModelChange={setSelectionModel}
//                             />

//                         </Box>
//                     )}
//                 </Box>
//             </Paper>

//             {/* Snackbar */}
//             <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//                 <Alert severity={snackbar.severity} variant="filled">
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// }





import { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
    Box, Grid, Paper, Typography, IconButton, Snackbar, Alert, Tooltip, Card,
    CardContent, Avatar, Checkbox, useMediaQuery, useTheme, CircularProgress,
    TextField, InputAdornment, Dialog, Button, DialogContent, Menu, MenuItem,
    Chip, Divider, DialogTitle, DialogActions, LinearProgress
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { VscNewFile } from 'react-icons/vsc';
import { FaFileExcel } from 'react-icons/fa';
import DeleteIcon from '@mui/icons-material/Delete';
import PhoneIcon from '@mui/icons-material/Phone';
import PersonIcon from '@mui/icons-material/Person';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SearchIcon from '@mui/icons-material/Search';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useAuth } from '../context/AuthContext';
import useDataLoadingState from '../hooks/useDataLoadingState';
import { motion, AnimatePresence } from 'framer-motion';
import SkeletonLoader from '../components/SkeletonLoader';
import LoadingOverlay from '../components/LoadingOverlay';
import LoadingSpinner from '../components/Common/LoadingSpinner';
import CommonServerDataGrid from '../components/datagridComponent';
import { formatRows } from '../utils/formatRows';
import NoDataComponent from '../components/NoDataComponent';
import CenterLoader from './Test/components/CenterLoader';
import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
import { APPBAR_HEIGHT } from '../utils/theme';
// import { showMessageFromRoute } from '../utils/showMessageFromRoute';

/**
 * Utility: Convert string to color
 */
function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
}

/**
 * Utility: Get initials from name
 */
function getInitials(name) {
    if (!name) return 'C';
    return name.trim().charAt(0).toUpperCase();
}

/**
 * CompanyDetail Component
 * 
 * Displays companies in two views:
 * - Desktop: CommonServerDataGrid with pagination, filtering, sorting
 * - Mobile: Card view with search and pagination
 * 
 * Features:
 * - Server-side pagination, filtering, sorting
 * - Search functionality for mobile view
 * - Bulk deletion
 * - Excel export
 * - Responsive design
 */
export default function CompanyDetail({ connectionString, drawerOpen }) {
    const API = `${connectionString}/api/company`;
    const { user, selectedCompany } = useAuth();
    const userId = user?.UserId;
    const role = user?.UserCategory;
    const AppRegID = selectedCompany?.AppRegID || null;
    const navigate = useNavigate();
    // const location = useLocation()

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));
    const PAGE_SIZE = 20;
    //  useEffect(() => {
    //   showMessageFromRoute(location, setSnackbar);
    // }, [location.state]);

    // ============ STATE MANAGEMENT ============

    // Shared state for both views
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [selectionModel, setSelectionModel] = useState([]);
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [selectAll, setSelectAll] = useState(false);
    const [rowsLoading, setRowsLoading] = useState(false)
    // Tracks a failed fetch distinctly from "genuinely no data" — without this,
    // a network/server error and an empty dataset both render the same
    // "Nothing here yet, add your first record" empty state, which is misleading.
    const [fetchError, setFetchError] = useState(false);
    // Desktop state (DataGrid)
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [sortModel, setSortModel] = useState([]);

    // Mobile state (Search + Pagination)
    const [mobileSearchQuery, setMobileSearchQuery] = useState('');
    const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
    const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: PAGE_SIZE });
    const [isFiltered, setIsFiltered] = useState(false);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
    const [deleting, setDeleting] = useState(false);
    const selectedIdsRef = useRef([]);
    const mainContainerRef = useRef(null);
    const selectedCompanyRef = useRef(null);

    // Context Menu State
    const [contextMenu, setContextMenu] = useState({ anchorPosition: null, company: null });

    // ReonConnect Dialog State
    const [reonDialogOpen, setReonDialogOpen] = useState(false);
    const [reonCode, setReonCode] = useState('');
    const [showGenerateButton, setShowGenerateButton] = useState(false);
    const [reonLoading, setReonLoading] = useState(false);

    // Company-limit-reached alert (blocks navigating to Add Company when the
    // AppRegID's plan has no room left, per the same MaxCompanies cap the
    // backend enforces on insert)
    const [limitDialog, setLimitDialog] = useState({ open: false, count: 0, maxCompanies: null });
    const [checkingLimit, setCheckingLimit] = useState(false);

    // 🔥 Add loading state hook (use rowsLoading for mobile view)
    const { showLoadingSpinner, showEmptyState } = useDataLoadingState(rowsLoading, rows?.length > 0);

    // ============ PARAMETER BUILDERS ============

    /**
     * Build parameters for mobile search request
     */

    const buildMobileParams = (pageNum, searchText) => {
        const offset = pageNum * PAGE_SIZE;
        const params = {
            mode: 'search',
            userId,
            offset,
            limit: PAGE_SIZE
        };

        if (searchText && searchText.trim()) {
            params.search = searchText; // Send search to backend
        }

        console.log('📦 buildMobileParams:', params);
        return params;
    };

    /**
     * Build parameters for desktop request with filters and sort
     */
    const buildDesktopParams = (pageNum, pageSize) => {
        const offset = pageNum * pageSize;
        const params = {
            mode: 'search',
            userId,
            offset,
            limit: pageSize
        };

        // Add filters from DataGrid
        filterModel.items.forEach(item => {
            if (item.value) {
                switch (item.field) {
                    case 'CompanyName':
                        params.CompanyName = item.value;
                        break;
                    case 'GSTNo':
                        params.GSTNo = item.value;
                        break;
                    case 'ContactPerson':
                        params.ContactPerson = item.value;
                        break;
                    case 'MobileNo':
                        params.MobileNo = item.value;
                        break;
                    case 'City':
                        params.City = item.value;
                        break;
                    default:
                        break;
                }
            }
        });

        // Add sorting
        if (sortModel.length > 0) {
            const sort = sortModel[0];
            params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
        }

        console.log('🖥️ buildDesktopParams:', params);
        return params;
    };


    // ============ FETCH FUNCTIONS ============

    /**
     * Fetch data for desktop view (with filters and sort)
     */
    const fetchDataDesktop = useCallback(async () => {
        if (isSmallScreen) return;

        console.log('🖥️ [DESKTOP] Fetching data...');
        setLoading(true);
        setRowsLoading(true)
        setFetchError(false);
        try {
            const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);

            // Fetch rows
            const dataRes = await axios.get(`${API}/search-by-user`, { params });
            const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
            // alert(fetchedRows.length);

            // ⭐ transform rows here
            setRows(formatRows(fetchedRows));
            setSelectionModel([]);
            selectedIdsRef.current = [];
            console.log(`🖥️ Fetched ${fetchedRows.length} rows`);

            // Fetch total count
            const countParams = { ...params };
            delete countParams.mode;
            delete countParams.offset;
            delete countParams.limit;
            delete countParams.orderBy;

            const countRes = await axios.get(`${API}/count-by-user`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);

            console.log(`🖥️ Total count: ${count}`);
        } catch (err) {
            console.error('🖥️ Fetch error:', err);
            setSnackbar({ open: true, message: 'Failed to fetch data.', severity: 'error' });
            setFetchError(true);
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
            setRowsLoading(false)
        }
    }, [API, userId, paginationModel, filterModel, sortModel, isSmallScreen]);



    /**
     * Fetch data for mobile view (with search only)
     */
    const fetchDataMobile = useCallback(async () => {
        console.log('📱 [MOBILE] Fetching data...');

        if (!isSmallScreen) {
            console.log('📱 Skipping - not small screen');
            return;
        }

        setLoading(true);
        setRowsLoading(true)
        setFetchError(false);
        try {
            const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);

            console.log('📱 API URL:', `${API}/search-by-user`);
            console.log('📱 Params:', JSON.stringify(params, null, 2));

            // Fetch rows
            const dataRes = await axios.get(`${API}/search-by-user`, { params });
            const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
            setRows(formatRows(fetchedRows));
            setSelectionModel([]);
            selectedIdsRef.current = [];
            console.log(`📱 Fetched ${fetchedRows.length} rows`);

            // Fetch total count
            const countParams = { ...params };
            delete countParams.mode;
            delete countParams.offset;
            delete countParams.limit;

            console.log('📱 Count params:', countParams);
            const countRes = await axios.get(`${API}/count-by-user`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);

            console.log(`📱 Total count: ${count}`);
        } catch (err) {
            console.error('📱 Fetch error:', err);
            console.error('📱 Error response:', err.response?.data);
            setSnackbar({ open: true, message: `Error: ${err.message}`, severity: 'error' });
            setFetchError(true);
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
            setRowsLoading(false)
        }
    }, [API, userId, mobilePaginationModel.page, debouncedMobileSearch, isSmallScreen]);

    // ============ EFFECTS ============

    // Memoize context menu handler to keep it always ready
    const handleContextMenuEvent = useCallback((e) => {
        console.log('🖱️ [CONTEXT MENU] Right-click detected');
        console.log('   Target element:', e.target.tagName, 'Class:', e.target.className);

        // Check if grid exists anywhere on the page
        const gridContainer = document.querySelector('[role="grid"]');
        console.log('   Grid found:', !!gridContainer);

        // Try to find the row element using closest()
        let rowElement = e.target.closest('[data-rowindex]') || e.target.closest('.MuiDataGrid-row');
        console.log('   Row element found (direct):', !!rowElement);

        // Check if this is a backdrop/modal overlay
        const isBackdrop = e.target.classList.contains('MuiBackdrop-root') || e.target.closest('.MuiBackdrop-root');
        console.log('   Is Backdrop:', isBackdrop);

        // If backdrop is in the way, find the closest row by click position
        if (isBackdrop && !rowElement) {
            console.log('   Checking for row near click position...');
            const allRows = document.querySelectorAll('[data-rowindex]');
            console.log('   Total rows found:', allRows.length);

            if (allRows.length > 0) {
                const clickX = e.clientX;
                const clickY = e.clientY;

                let closestRow = null;
                let closestDistance = Infinity;

                allRows.forEach(row => {
                    const rect = row.getBoundingClientRect();
                    const rowCenterX = rect.left + rect.width / 2;
                    const rowCenterY = rect.top + rect.height / 2;
                    const distance = Math.hypot(clickX - rowCenterX, clickY - rowCenterY);

                    console.log('   Row at Y:', rect.top, 'Distance:', distance.toFixed(0));

                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestRow = row;
                    }
                });

                if (closestRow && closestDistance < 300) {
                    // Only use if close enough (within 300px)
                    rowElement = closestRow;
                    console.log('   ✅ Closest row found at distance:', closestDistance.toFixed(0));
                } else {
                    console.log('   ❌ No row close enough to click');
                }
            }
        }

        // Check if within the companies container OR within grid OR on backdrop
        const isWithinCompanies = mainContainerRef.current && mainContainerRef.current.contains(e.target);
        const isWithinGrid = gridContainer && gridContainer.contains(e.target);
        const shouldHandle = isWithinCompanies || isWithinGrid || isBackdrop || rowElement;

        console.log('   Should handle:', shouldHandle);

        if (shouldHandle) {
            console.log('✅ [CONTEXT MENU] Handling context menu');
            e.preventDefault();

            // If row element found, open menu
            if (rowElement) {
                const rowIndex = rowElement.getAttribute('data-rowindex');
                console.log('📍 [CONTEXT MENU] Row index:', rowIndex);
                if (rowIndex !== null && rows[rowIndex]) {
                    console.log('🎯 [CONTEXT MENU] Row found:', rows[rowIndex].CompanyName);
                    handleRowContextMenu(e, rows[rowIndex]);
                } else {
                    console.log('⚠️ [CONTEXT MENU] Row index found but row data not available');
                }
            } else {
                // Close menu if not on a row
                console.log('⚠️ [CONTEXT MENU] Not on a row - closing menu');
                handleContextMenuClose();
            }
        } else {
            console.log('❌ [CONTEXT MENU] Not within companies area');
        }
    }, [rows]);

    /**
     * Handle global context menu - Keep listener always active
     */
    useEffect(() => {
        console.log('📌 [CONTEXT LISTENER] Setting up right-click listener');
        document.addEventListener('contextmenu', handleContextMenuEvent, true);

        return () => {
            console.log('❌ [CONTEXT LISTENER] Removing right-click listener');
            document.removeEventListener('contextmenu', handleContextMenuEvent, true);
        };
    }, [handleContextMenuEvent]);

    /**
     * Close menu on left click - Separate effect to keep it active
     */
    useEffect(() => {
        console.log('📌 [CLICK HANDLER] Setting up left-click listener');
        const handleClickAnywhere = (e) => {
            const menu = document.querySelector('[role="menu"]');
            const dialog = document.querySelector('[role="dialog"]');

            console.log('👆 [CLICK] Left-click detected');

            // Close context menu only if not clicking on menu or dialog
            if ((!menu || !menu.contains(e.target)) && (!dialog || !dialog.contains(e.target))) {
                console.log('🔄 [CLICK] Closing context menu');
                handleContextMenuClose();
            } else if (menu && menu.contains(e.target)) {
                console.log('⚠️ [CLICK] Click on menu - keeping menu open');
            } else if (dialog && dialog.contains(e.target)) {
                console.log('⚠️ [CLICK] Click on dialog - keeping menu open');
            }
        };

        document.addEventListener('click', handleClickAnywhere, false);

        return () => {
            console.log('❌ [CLICK HANDLER] Removing left-click listener');
            document.removeEventListener('click', handleClickAnywhere, false);
        };
    }, []);

    /**
     * Trigger desktop fetch when pagination, filters, or sort changes
     */
    useEffect(() => {
        console.log('💻 [EFFECT] Desktop dependencies changed');
        if (!isSmallScreen) {
            fetchDataDesktop();
        }
    }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isSmallScreen, fetchDataDesktop]);

    // /**
    //  * Trigger mobile fetch when pagination changes
    //  */
    useEffect(() => {
        console.log('📱 [EFFECT] Mobile pagination changed:', mobilePaginationModel);
        if (isSmallScreen) {
            fetchDataMobile();
        }
    }, [mobilePaginationModel.page,mobilePaginationModel.pageSize, debouncedMobileSearch, isSmallScreen]);

    /**
     * Debounce mobile search and trigger fetch
     */
    useEffect(() => {
        console.log('⏱️ [DEBOUNCE] Starting 400ms timeout for:', mobileSearchQuery);

        const timer = setTimeout(() => {
            console.log('⏱️ [DEBOUNCE] Timer completed! Setting search to:', mobileSearchQuery);
            setDebouncedMobileSearch(mobileSearchQuery);
            setMobilePaginationModel(prev => ({
                ...prev,
                page: 0   // only reset page
            }));
        }, 400);

        return () => {
            console.log('⏱️ [DEBOUNCE] Cleared timeout');
            clearTimeout(timer);
        };
    }, [mobileSearchQuery]);

    /**
     * Trigger fetch when debounced search changes
     */
    // useEffect(() => {
    //     console.log('📱 [EFFECT] Debounced search changed:', debouncedMobileSearch);
    //     if (isSmallScreen) {
    //         fetchDataMobile();
    //     }
    // }, [debouncedMobileSearch, isSmallScreen, fetchDataMobile]);

    // ============ DELETE HANDLER ============

    const handleDeleteMulti = async () => {
        // if (selectionModel.length === 0) return;
        const ids = selectedIdsRef.current;
        if (!ids.length || deleting) return;
        setDeleting(true);

        try {
            const response = await axios.post(`${API}/delete`, {
                userId,
                objAryId: ids
            });

            setSnackbar({
                open: true,
                message: response.data.message || 'Deleted successfully.',
                severity: 'success'
            });

            setSelectionModel([]);
            selectedIdsRef.current = [];
            setSelectAll(false);

            // Refetch data
            if (isSmallScreen) {
                fetchDataMobile();
            } else {
                fetchDataDesktop();
            }
        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;
            // 🔴 Case: 400 + referenced IDs (business rule failure)
            if (status === 400 && data?.referencedIds?.length > 0) {
                setSnackbar({
                    open: true,
                    message: "Cannot delete the selected item(s) because they are referenced in other records.",
                    severity: "warning"
                });
            } else if (status === 400 && data?.error) {
                // 🔴 400 but no referencedIds array (generic validation)
                setSnackbar({
                    open: true,
                    message: data.error,
                    severity: "warning"
                });
            } else {
                // 🔴 unexpected / server error
                setSnackbar({
                    open: true,
                    message: "Delete failed due to an unexpected error.",
                    severity: "error"
                });
            }
        } finally {
            setDeleting(false);
            setConfirmOpen(false);
        }
    };

    // ============ EXPORT HANDLER ============

    const handleExport = () => {
        axios({
            url: `${API}/search-by-user?mode=export&userId=${userId}`,
            method: 'GET',
            responseType: 'blob',
        })
            .then((resp) => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'companies.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .catch(() => {
                setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
            });
    };

    // Blocks navigating to /main/newCompany when this AppRegID's plan has no
    // room left — mirrors the backend's assertCompanyLimitNotReached check on
    // insert, so the user sees an alert instead of the create form.
    const handleAddCompanyClick = async (e) => {
        if (!AppRegID) return; // no company selected yet — let the link through, backend still enforces the cap
        e.preventDefault();
        setCheckingLimit(true);
        try {
            const res = await axios.get(`${connectionString}/api/company/limit-status`, {
                params: { appRegId: AppRegID },
            });
            const { count, maxCompanies, reached } = res.data;
            if (reached) {
                setLimitDialog({ open: true, count, maxCompanies });
            } else {
                navigate('/main/newCompany');
            }
        } catch (err) {
            // If the check itself fails, don't block the user — let them proceed
            // and rely on the backend's own enforcement on submit.
            navigate('/main/newCompany');
        } finally {
            setCheckingLimit(false);
        }
    };

    // ============ CONTEXT MENU HANDLERS ============

    const handleRowContextMenu = (e, company) => {
        console.log('📂 [CONTEXT MENU] Opening menu for:', company.CompanyName);
        console.log('   Position - X:', e.clientX, 'Y:', e.clientY);
        e.preventDefault();
        setContextMenu({
            anchorPosition: { top: e.clientY, left: e.clientX },
            company: company
        });
    };

    const handleContextMenuClose = () => {
        console.log('❌ [CONTEXT MENU] Closing menu');
        setContextMenu({ anchorPosition: null, company: null });
    };

    const handleOpenReonDialog = async (company) => {
        console.log('🔗 [REON DIALOG] Opening for company:', company.CompanyName);
        console.log('   CompId:', company.CompId);
        selectedCompanyRef.current = company;
        handleContextMenuClose();
        setReonCode('');
        setShowGenerateButton(false);
        setReonLoading(true);
        setReonDialogOpen(true);

        try {
            console.log('🔍 [REON API] Checking if ReonConnectId exists...');
            const response = await axios.get(`${connectionString}/api/reonconnect/check`, {
                params: { CompId: company.CompId }
            });

            console.log('✅ [REON API] Check response:', response.data);
            if (response.data.exists) {
                console.log('📋 [REON] Code exists:', response.data.ReonConnectId);
                setReonCode(response.data.ReonConnectId);
                setShowGenerateButton(false);
            } else {
                console.log('📋 [REON] No code exists, showing generate button');
                setReonCode('');
                setShowGenerateButton(true);
            }
        } catch (error) {
            console.error('❌ [REON API] Error checking ReonConnect ID:', error);
            setSnackbar({ open: true, message: 'Error checking ReonConnect code', severity: 'error' });
            setShowGenerateButton(true);
        } finally {
            console.log('⏹️ [REON] Finished loading');
            setReonLoading(false);
        }
    };

    const handleGenerateReonCode = async () => {
        console.log('🔄 [REON GENERATE] Starting code generation');
        if (!selectedCompanyRef.current) {
            console.log('❌ [REON GENERATE] No company selected');
            return;
        }

        const company = selectedCompanyRef.current;
        console.log('📤 [REON GENERATE] Sending request for CompId:', company.CompId);
        console.log('   Company:', company.CompanyName);
        console.log('   GCompId:', company.GCompId);
        setReonLoading(true);
        try {
            const response = await axios.post(`${connectionString}/api/reonconnect/generate`, {
                CompId: company.CompId,
                GCompId: company.GCompId || company.CompId,
                AddUserId: userId
            });

            console.log('✅ [REON GENERATE] Response:', response.data);
            if (response.data.success) {
                console.log('🎉 [REON GENERATE] Code generated:', response.data.ReonConnectId);
                setReonCode(response.data.ReonConnectId);
                setShowGenerateButton(false);
                setSnackbar({
                    open: true,
                    message: 'ReonConnect code generated successfully!',
                    severity: 'success'
                });
            }
        } catch (error) {
            console.error('❌ [REON GENERATE] Error generating ReonConnect code:', error);
            setSnackbar({
                open: true,
                message: 'Error generating ReonConnect code',
                severity: 'error'
            });
        } finally {
            console.log('⏹️ [REON GENERATE] Finished');
            setReonLoading(false);
        }
    };

    const handleReonDialogClose = () => {
        console.log('🔒 [REON DIALOG] Closing dialog');
        selectedCompanyRef.current = null;
        setReonDialogOpen(false);
        setReonCode('');
        setShowGenerateButton(false);
    };

    // ============ SELECT ALL TOGGLE ============

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectionModel([]);
            selectedIdsRef.current = [];
            setSelectAll(false);
        } else {
            const allIds = rows.map(row => row.CompId);
            setSelectionModel(allIds);
            selectedIdsRef.current = allIds; // 🔥 freeze
            setSelectAll(true);
        }
    };

    // ============ COLUMNS DEFINITION ============

    const columns = [
        {
            field: 'CompanyName',
            headerName: 'Company',
            flex: 1.5,
            minWidth: 150,
            renderCell: (params) => {
                const companyId = params.row.CompId;
                // ✅ row se lo, value se nahi
                const companyName = params.row.CompanyName;

                const handleClick = (e) => {
                    if (role === 'User') {
                        e.preventDefault();
                        setSnackbar({ open: true, message: '403 Forbidden: Access Denied', severity: 'warning' });
                    }
                };

                return (
                    <Link
                        to={`/main/editCompany/${companyId}`}
                        style={{
                            color: '#1976d2',
                            textDecoration: 'underline',
                            fontWeight: 500,
                            fontSize: '0.875rem'
                        }}
                        onClick={handleClick}
                    >
                        {companyName || '—'}
                    </Link>
                );
            }
        },
        {
            field: 'GSTNo',
            headerName: 'GST No.',
            flex: 1,
            minWidth: 120
        },
        {
            field: 'ContactPerson',
            headerName: 'Contact',
            flex: 1,
            minWidth: 120
        },
        {
            field: 'MobileNo',
            headerName: 'Mobile',
            flex: 0.7,
            minWidth: 120,
            align: 'right',
            headerAlign: 'right'
        },
        {
            field: 'location',
            headerName: 'Location',
            flex: 0.45,
            minWidth: 120,
            sortable: false,
            filterable: true,
            valueGetter: (value, row) => [row.City, row.State, row.Country].filter(Boolean).join(', '),
            renderCell: (params) => {
                const { City, State, Country } = params.row;
                return (
                    <Box sx={{ py: 1, display: 'flex', flexDirection: 'column' }}>
                        <Typography sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}>{City || '—'}</Typography>
                        <Typography sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}>{State || '—'}</Typography>
                        <Typography sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}>{Country || '—'}</Typography>
                    </Box>
                );
            }
        },
    ];

    // Add delete button column if not User
    if (role !== "User") {
        columns.push({
            width: 40,
            sortable: false,
            filterable: false,
            align: "center",
            headerAlign: "center",
            renderCell: ({ row }) => {
                const isSelected = selectionModel.includes(row.CompId);
                return (
                    <Tooltip title="Delete Selected">
                        <span>
                            <IconButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    selectedIdsRef.current = selectionModel;   // 🔥 SYNC HERE
                                    setPendingDeleteIds(selectionModel);
                                    setConfirmOpen(true);
                                }}
                                color="error"
                                disabled={!isSelected}
                                size="small"
                            >
                                <DeleteIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        });
    }

    // ============ FETCH ERROR STATE ============
    // Distinct from "genuinely no data" (NoDataComponent) — shown when the
    // last fetch failed, so the user isn't told "add your first record" when
    // the real problem is the request itself failing.
    const renderFetchError = (onRetry) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', textAlign: 'center', px: 2, py: 6 }}>
            <ErrorOutlineIcon sx={{ fontSize: 48, color: 'error.main', mb: 2 }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>
                Couldn't load companies
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3, maxWidth: 360 }}>
                Something went wrong while fetching this data. Check your connection and try again.
            </Typography>
            <Button variant="outlined" startIcon={<RefreshIcon />} onClick={onRetry}>
                Retry
            </Button>
        </Box>
    );

    // ============ CARD RENDERING (MOBILE) ============

    const renderCards = () => {
        if (showLoadingSpinner) {
            return <SkeletonLoader count={4} height={80} />;
        }

        if (fetchError) {
            return renderFetchError(fetchDataMobile);
        }

        if (showEmptyState) {
            return (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography sx={{ color: 'text.secondary', mb: 2 }}>
                        {mobileSearchQuery ? <CustomNoDataOverlay /> : <NoDataComponent />}
                    </Typography>
                    <Typography sx={{ color: 'text.secondary', fontSize: '0.85rem' }}>
                        Search: "{debouncedMobileSearch}" | Page: {mobilePaginationModel.page} | Total: {totalCount}
                    </Typography>
                </Box>
            );
        }

        return (
            <>
                {rows.map((row) => {
                    const isSelected = selectionModel.includes(row.CompId);
                    const avatarColor = stringToColor(row.CompanyName || 'Company');
                    const initials = getInitials(row.CompanyName);
                    const locationText = [row.City, row.State, row.Country].filter(Boolean).join(', ') || '—';

                    const toggleSelection = (e) => {
                        e.stopPropagation();
                        setSelectionModel(prev => {
                            const updated = prev.includes(row.CompId)
                                ? prev.filter(id => id !== row.CompId)
                                : [...prev, row.CompId]
                            selectedIdsRef.current = updated;
                            return updated
                        });
                    };

                    return (
                        <Card
                            key={row.CompId}
                            sx={{
                                mb: 1.5,
                                boxShadow: 1,
                                borderRadius: 2,
                                overflow: 'hidden',
                                transition: '0.2s',
                                '&:hover': { boxShadow: 3 },
                                cursor: 'pointer'
                            }}
                            onClick={() => {
                                if (role === 'User') {
                                    setSnackbar({ open: true, message: '403 Forbidden: Access Denied', severity: 'warning' });
                                    return;
                                }
                                window.location.href = `/main/editCompany/${row.CompId}`;
                            }}
                        >
                            {/* Gradient top strip */}
                            <Box sx={{
                                height: 5,
                                background: `linear-gradient(90deg, ${avatarColor} 0%, ${avatarColor}88 100%)`
                            }} />

                            <CardContent sx={{ py: 1.5, px: 1.5, pb: '10px !important' }}>
                                {/* Header row: Checkbox + Avatar + Company Name + Location */}
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                    {role !== 'User' && (
                                        <Checkbox
                                            checked={isSelected}
                                            onChange={toggleSelection}
                                            onClick={(e) => e.stopPropagation()}
                                            size="small"
                                            sx={{ p: 0.2, mt: 0.3, mr: 0.5, flexShrink: 0 }}
                                        />
                                    )}
                                    <Avatar
                                        sx={{
                                            bgcolor: avatarColor,
                                            color: '#fff',
                                            width: 38,
                                            height: 38,
                                            fontWeight: 'bold',
                                            mr: 1.5,
                                            flexShrink: 0
                                        }}
                                    >
                                        {initials}
                                    </Avatar>
                                    <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                                        <Typography
                                            variant="subtitle1"
                                            sx={{
                                                color: '#1976d2',
                                                fontWeight: 700,
                                                fontSize: '0.95rem',
                                                lineHeight: 1.2,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {row.CompanyName || '—'}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.2 }}>
                                            {locationText}
                                        </Typography>
                                    </Box>
                                </Box>

                                <Divider sx={{ my: 0.8 }} />

                                {/* Info area */}
                                <Box sx={{ mt: 0.8 }}>
                                    {row.ContactPerson && (
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.8 }}>
                                            <PersonIcon sx={{ color: 'text.secondary', mr: 0.8, flexShrink: 0, fontSize: '0.95rem' }} />
                                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {row.ContactPerson}
                                            </Typography>
                                        </Box>
                                    )}

                                    {/* Chip badges */}
                                    <Box sx={{ display: 'flex', gap: 0.8, flexWrap: 'wrap', mt: 0.5 }}>
                                        {row.GSTNo && (
                                            <Chip
                                                icon={<ReceiptIcon />}
                                                label={`GST: ${row.GSTNo}`}
                                                size="small"
                                                variant="outlined"
                                                sx={{ fontSize: '0.7rem', height: 22 }}
                                            />
                                        )}
                                        {row.MobileNo && (
                                            <Chip
                                                icon={<PhoneIcon />}
                                                label={row.MobileNo}
                                                size="small"
                                                color="primary"
                                                sx={{ fontSize: '0.7rem', height: 22 }}
                                            />
                                        )}
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}

                {/* Mobile Pagination Controls */}
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 2, mt: 1 }}>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<NavigateBeforeIcon />}
                        onClick={() => setMobilePaginationModel(p => ({ ...p, page: Math.max(0, p.page - 1) }))}
                        disabled={mobilePaginationModel.page === 0}
                    >
                        Prev
                    </Button>

                    <Typography variant="body2" sx={{ minWidth: '120px', textAlign: 'center' }}>
                        Page {mobilePaginationModel.page + 1} of {Math.ceil(totalCount / mobilePaginationModel.pageSize) || 1}
                    </Typography>

                    <Button
                        variant="outlined"
                        size="small"
                        endIcon={<NavigateNextIcon />}
                        onClick={() => setMobilePaginationModel(p => ({ ...p, page: p.page + 1 }))}
                        disabled={(mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount}
                    >
                        Next
                    </Button>
                </Box>
            </>
        );
    };

    // ============ RENDER ============

    return (
         <Box ref={mainContainerRef} sx={{
            pt: 0.7, px: { xs: 2, sm: 3, md: 4 }, display: 'flex',
            flexDirection: 'column', height: `calc(100vh - ${APPBAR_HEIGHT}px)`,
        }}>

            {/* ── Module Header ──────────────────────────────────────────────
                Blue gradient strip + Paper bar for consistent branding.
                Title on the left, Export + Add Company on the right.
            ────────────────────────────────────────────────────────────────── */}
            <Box sx={{ mb: 1.5 }}>
                <Box sx={{ height: 4, background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)', borderRadius: '6px 6px 0 0' }} />
                <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderTop: 0, borderRadius: '0 0 8px 8px', px: 2, py: 1.2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                        Companies
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {/* Export company list to Excel */}
                        <Tooltip title="Export to Excel">
                            <Button startIcon={<FaFileExcel />} variant="outlined" onClick={handleExport} color="success" size="small">
                                Export
                            </Button>
                        </Tooltip>
                        {/* Navigate to the Add New Company form, unless this AppRegID's plan is at its company cap */}
                        <Button
                            startIcon={<AddIcon />}
                            variant="contained"
                            size="small"
                            component={Link}
                            to="/main/newCompany"
                            onClick={handleAddCompanyClick}
                            disabled={checkingLimit}
                        >
                            Add Company
                        </Button>
                    </Box>
                </Paper>
            </Box>


            {/* Content */}
                   <Paper elevation={3} sx={{borderRadius: 2, overflow: 'hidden',  flex: 1, display: 'flex',  flexDirection: 'column', minHeight: 0,   marginBottom: "12px" }}>
                <Box sx={{ p: { xs: 0.5, md: 0.5 }, display: 'flex', flexDirection: 'column',flex: 1, minHeight: 0 }}>  
                    {/* Mobile Search Field */}
                    {isSmallScreen && (
                        <Box sx={{ mb: 2, px: 1 }}>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="Search companies..."
                                value={mobileSearchQuery}
                                onChange={(e) => setMobileSearchQuery(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined"
                            />
                        </Box>
                    )}

                    {/* Debug Info */}
                    {/* {isSmallScreen && (
                        <Box sx={{ mb: 2, p: 1, bgcolor: '#f0f0f0', borderRadius: 1, fontSize: '0.75rem' }}>
                            <Typography sx={{ fontSize: '0.75rem', color: '#666' }}>
                                Debug: Search="{debouncedMobileSearch}" | Page={mobilePaginationModel.page} | Rows={rows.length} | Total={totalCount} | Loading={loading ? 'Yes' : 'No'}
                            </Typography>
                        </Box>
                    )} */}

                    {/* Bulk Action Bar - Mobile Only */}
                    {isSmallScreen && role !== 'User' && selectionModel.length > 0 && (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                px: 2,
                                py: 1.5,
                                mb: 2,
                                bgcolor: 'background.paper',
                                borderRadius: 2,
                                boxShadow: 1
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox
                                    checked={selectAll}
                                    onChange={toggleSelectAll}
                                    size="small"
                                />
                                <Typography variant="body2" sx={{ ml: 1 }}>
                                    {selectionModel.length} selected
                                </Typography>
                            </Box>
                            <Tooltip title="Delete selected">
                                <IconButton onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    selectedIdsRef.current = selectionModel;   // 🔥 SYNC HERE
                                    setPendingDeleteIds(selectionModel);
                                    setConfirmOpen(true);
                                }} color="error">
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}

                    {/* Mobile View - Cards */}
                    {isSmallScreen ? (
                       <Box sx={{ width: '100%', overflowX: 'hidden', px: 1, flex: 1, overflowY: 'auto', position: 'relative'}}>
                            {renderCards()}
                        </Box>
                    ) : (
                        /* Desktop View - CommonServerDataGrid */
                        <Box
                            sx={{ flex: 1, width: '100%', minHeight: 0, position: 'relative' }}
                        >
                            <LoadingOverlay isVisible={showLoadingSpinner} />
                            {
                                fetchError ? (
                                    renderFetchError(fetchDataDesktop)
                                ) : showEmptyState && !isFiltered ? (
                                    <NoDataComponent />
                                ) : (
                                    <CommonServerDataGrid
                                        data={rows}
                                        // loading={loading}
                                        columns={columns}
                                        getRowId={(row) => row.CompId}
                                        role={role}
                                        pageSizeOptions={[50, 100]}
                                        selectionModel={selectionModel}
                                        onSelectionModelChange={setSelectionModel}
                                        onPageChange={({ page, pageSize }) => {
                                            setPaginationModel({ page, pageSize });
                                        }}
                                        onFilterChange={setFilterModel}
                                        onSortChange={setSortModel}
                                        rowCount={totalCount}
                                        onFilterStatusChange={setIsFiltered}  // <-- new prop
                                    />
                                )
                            }

                        </Box>

                    )}
                </Box>
            </Paper>

            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar(s => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity={snackbar.severity} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>

            {/* ── Delete Confirmation Dialog ──────────────────────────── */}
            <Dialog open={confirmOpen} onClose={() => { if (!deleting) setConfirmOpen(false); }} maxWidth="xs" fullWidth>
                {deleting
                    ? <LinearProgress color="error" sx={{ height: 4 }} />
                    : <Box sx={{ height: 4, background: 'linear-gradient(90deg, #d32f2f 0%, #f44336 100%)' }} />}
                <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                    <Typography variant="h6" fontWeight={700} sx={{ color: 'error.main', fontSize: '1.05rem' }}>Confirm Deletion</Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Are you sure you want to delete{' '}
                        <Typography component="span" variant="body2" fontWeight={700} color="error.main">{pendingDeleteIds.length}</Typography>
                        {' '}company record(s)? This action cannot be undone.
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={() => setConfirmOpen(false)} variant="outlined" color="inherit" size="small" disabled={deleting}>Cancel</Button>
                    <Button color="error" variant="contained" size="small" disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={14} color="inherit" /> : <DeleteIcon />}
                        onClick={handleDeleteMulti}>{deleting ? 'Deleting…' : 'Delete'}</Button>
                </Box>
            </Dialog>

            {/* ── Context Menu (Right-Click) ──────────────────────────── */}
            <Menu
                anchorPosition={contextMenu.anchorPosition}
                anchorReference="anchorPosition"
                open={Boolean(contextMenu.anchorPosition)}
                onClose={handleContextMenuClose}
            >
                <MenuItem onClick={() => handleOpenReonDialog(contextMenu.company)}>
                    Connect Reon
                </MenuItem>
            </Menu>

            {/* ── ReonConnect Dialog ──────────────────────────── */}
            <Dialog open={reonDialogOpen} onClose={handleReonDialogClose} maxWidth="xs" fullWidth>
                <Box sx={{ height: 4, background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)' }} />

                <Box sx={{ px: 2, pt: 1.5, pb: 1 }}>
                    <Typography variant="h6" fontWeight={700} sx={{ color: 'primary.main', fontSize: '1.1rem', mb: 0.3 }}>
                        🔗 Connect Reon
                    </Typography>
                    {contextMenu.company && (
                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                            {contextMenu.company.CompanyName}
                        </Typography>
                    )}
                </Box>

                <Divider sx={{ my: 0 }} />

                <Box sx={{ px: 2, py: 2 }}>
                    {reonLoading && !reonCode ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', py: 2 }}>
                            <CircularProgress size={28} sx={{ mb: 1 }} />
                            <Typography variant="caption" color="text.secondary">
                                Checking code...
                            </Typography>
                        </Box>
                    ) : (
                        <>
                            <Box sx={{ mb: 1.5 }}>
                                <Typography variant="caption" fontWeight={600} sx={{ mb: 0.8, color: '#333', fontSize: '0.8rem', display: 'block' }}>
                                    ReonConnect Code
                                </Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={reonCode}
                                    readOnly
                                    variant="outlined"
                                    placeholder="No code generated yet"
                                    sx={{
                                        mb: 0.5,
                                        '& .MuiOutlinedInput-root': {
                                            fontFamily: 'monospace',
                                            fontSize: '0.95rem',
                                            fontWeight: 700,
                                            letterSpacing: '1.5px',
                                            padding: '8px 10px',
                                            backgroundColor: reonCode ? '#f0f7ff' : '#fafafa'
                                        },
                                        '& .MuiOutlinedInput-input': {
                                            textAlign: 'center',
                                            color: reonCode ? '#1976d2' : '#999'
                                        }
                                    }}
                                />
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5, fontSize: '0.75rem' }}>
                                    {reonCode ? '✓ Copy code to connect with Reon' : '• Click "Generate" to create code'}
                                </Typography>
                            </Box>

                            {showGenerateButton && (
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    onClick={handleGenerateReonCode}
                                    disabled={reonLoading}
                                    size="small"
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        fontSize: '0.85rem',
                                        padding: '7px 16px',
                                        borderRadius: '5px'
                                    }}
                                >
                                    {reonLoading ? 'Generating...' : '+ Generate'}
                                </Button>
                            )}
                        </>
                    )}
                </Box>

                <Divider sx={{ my: 0 }} />

                <Box sx={{ px: 2, py: 1.2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button
                        onClick={handleReonDialogClose}
                        variant="outlined"
                        color="inherit"
                        sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '6px' }}
                    >
                        Close
                    </Button>
                    {reonCode && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={async (e) => {
                              e.preventDefault();
                              e.stopPropagation();

                              const codeValue = reonCode?.toString().trim();
                              console.log('🔄 Copy button clicked');
                              console.log('Code value:', codeValue);
                              console.log('Code length:', codeValue?.length);

                              if (!codeValue || codeValue.length === 0) {
                                console.log('❌ Code value is empty');
                                setSnackbar({
                                  open: true,
                                  message: 'No code to copy',
                                  severity: 'warning'
                                });
                                return;
                              }

                              try {
                                // Method 1: Clipboard API (modern browsers)
                                if (navigator?.clipboard) {
                                  console.log('📋 Trying Clipboard API...');
                                  await navigator.clipboard.writeText(codeValue);
                                  console.log('✅ SUCCESS: Copied via Clipboard API');
                                  setSnackbar({
                                    open: true,
                                    message: 'Code copied to clipboard!',
                                    severity: 'success'
                                  });
                                } else {
                                  throw new Error('Clipboard API not available');
                                }
                              } catch (err) {
                                console.log('⚠️ Clipboard API failed, trying fallback...');
                                console.error('Clipboard error:', err);

                                // Method 2: execCommand fallback
                                try {
                                  const textArea = document.createElement('textarea');
                                  textArea.value = codeValue;
                                  textArea.setAttribute('readonly', '');
                                  textArea.style.position = 'fixed';
                                  textArea.style.top = '0';
                                  textArea.style.left = '0';
                                  textArea.style.opacity = '0';
                                  textArea.style.pointerEvents = 'none';
                                  document.body.appendChild(textArea);

                                  console.log('📋 Element created:', textArea);
                                  textArea.select();
                                  textArea.setSelectionRange(0, codeValue.length);

                                  const copySuccess = document.execCommand('copy');
                                  console.log('📋 execCommand result:', copySuccess);

                                  document.body.removeChild(textArea);

                                  if (copySuccess) {
                                    console.log('✅ SUCCESS: Copied via execCommand');
                                    setSnackbar({
                                      open: true,
                                      message: 'Code copied to clipboard!',
                                      severity: 'success'
                                    });
                                  } else {
                                    throw new Error('execCommand copy returned false');
                                  }
                                } catch (fallbackErr) {
                                  console.error('❌ Both methods failed:', fallbackErr);
                                  setSnackbar({
                                    open: true,
                                    message: 'Copy failed. Code: ' + codeValue,
                                    severity: 'error'
                                  });
                                }
                              }
                            }}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                borderRadius: '6px',
                                boxShadow: '0 2px 8px rgba(25, 118, 210, 0.2)',
                                '&:hover': {
                                    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
                                }
                            }}
                        >
                            📋 Copy Code
                        </Button>
                    )}
                </Box>
            </Dialog>

            {/* Company-limit-reached alert — blocks the Add Company navigation */}
            <Dialog open={limitDialog.open} onClose={() => setLimitDialog((d) => ({ ...d, open: false }))} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ fontWeight: 700 }}>Company Limit Reached</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" color="text.secondary">
                        You've reached your plan's company limit ({limitDialog.count}/{limitDialog.maxCompanies}).
                        Upgrade your plan to add more companies.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button variant="contained" onClick={() => setLimitDialog((d) => ({ ...d, open: false }))}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}